/**
 * Отступ окна от края экрана — доля высоты экрана. Совпадает с `max-height: 90vh` у
 * `ModalContainer`: окно максимальной высоты стоит ровно по 5vh сверху и снизу.
 */
export const MODAL_EDGE_RATIO = 0.05;

export interface ModalTopParams {
  viewportHeight: number;
  modalHeight: number;
  /** Нынешний верх окна; `undefined` — окно только открывается. */
  pinnedTop?: number;
  /** Минимальный отступ от верхнего и нижнего края экрана. */
  edge: number;
}

/**
 * Верх окна (IMGM-1623): при открытии — по центру, дальше верх закреплён и окно растёт вниз.
 * Если низ упирается в край экрана, окно поднимается ровно на нехватку, но не выше `edge`.
 * Окно, которое сжалось, вниз не возвращается — иначе верх снова прыгал бы.
 */
export function getModalTop({ viewportHeight, modalHeight, pinnedTop, edge }: ModalTopParams): number {
  const top = pinnedTop ?? (viewportHeight - modalHeight) / 2;
  const lowest = viewportHeight - edge - modalHeight;

  return Math.round(Math.max(edge, Math.min(top, lowest)));
}
